import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { FileText, Mail, Clock } from 'lucide-react';

const InvoiceSuccessPage = () => {
  const location = useLocation();
  const customerEmail = location.state?.customerEmail;

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#fef3c7] via-[#fef9eb] to-white pt-28 pb-16 px-4" data-testid="invoice-success-page">
      <div className="container mx-auto max-w-2xl">
        <Card className="border-0 shadow-xl">
          <CardContent className="pt-12 pb-12 text-center">
            <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-[#f59e0b]/10 mb-6">
              <FileText className="w-10 h-10 text-[#f59e0b]" />
            </div>
            <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-3">
              Demande enregistrée
            </h1>
            <p className="text-gray-600 text-base mb-2">
              Merci ! Votre demande d'abonnement avec paiement par facture QR a bien été enregistrée.
            </p>
            {customerEmail && (
              <p className="text-sm text-gray-500 mb-8">
                Email de confirmation envoyé à <strong className="text-gray-700">{customerEmail}</strong>
              </p>
            )}

            <div className="bg-[#fef3c7] border-l-4 border-[#f59e0b] rounded-r-lg p-5 text-left max-w-md mx-auto mb-8">
              <div className="flex items-start gap-3 mb-3">
                <Clock className="w-5 h-5 text-[#d97706] flex-shrink-0 mt-0.5" />
                <div>
                  <p className="font-semibold text-gray-900">Vous recevrez votre facture QR sous 24h ouvrables</p>
                  <p className="text-sm text-gray-600 mt-1">Votre abonnement sera activé dès réception du paiement.</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-[#d97706] flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-sm text-gray-700">Pour toute question, contactez-nous à <a href="mailto:info@car-main.ch" className="text-[#d97706] font-medium hover:underline">info@car-main.ch</a></p>
                </div>
              </div>
            </div>

            <Link to="/">
              <Button className="bg-[#52a675] hover:bg-[#3d8a5c] text-white px-8 py-6" data-testid="invoice-success-home-button">
                Retour à l'accueil
              </Button>
            </Link>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default InvoiceSuccessPage;
